function genNotification (type) {
  return function (message) {
    this.$store.dispatch('Dialogs/showNotification', {message: message, type: type})
  }
}

function error (err) {
  if (typeof err.response !== 'undefined' && typeof err.response.body !== 'undefined') {
    if (typeof err.response.body.errors !== 'undefined') {
      const messages = [err.response.body.exception, ...err.response.body.errors.map(error => error.defaultMessage)].join('<br>')
      this.$store.dispatch('Dialogs/showAlert', {title: 'Error: ' + err.response.body.message, message: messages})
    } else if (typeof err.response.body.messages !== 'undefined') {
      if (Array.isArray(err.response.body.message)) {
        const messages = err.reponse.body.messages.join('<br>')
        this.$store.dispatch('Dialogs/showAlert', {title: 'Error', message: messages})
      } else {
        this.$store.dispatch('Dialogs/showAlert', {title: 'Error', message: err.response.body.messages})
      }
    } else if (typeof err.response.body.message !== 'undefined') {
      this.$store.dispatch('Dialogs/showAlert', {title: 'Error', message: err.response.body.message})
    } else {
      this.$store.dispatch('Dialogs/showNotification', {message: err, type: 'error'})
    }
  } else if (typeof err.message !== 'undefined') {
    this.$store.dispatch('Dialogs/showNotification', {message: err.message, type: 'error'})
  } else {
    this.$store.dispatch('Dialogs/showNotification', {message: err, type: 'error'})
  }
}

const Notification = {
  install (Vue, options) {
    Vue.prototype.$error = error
    Vue.prototype.$warning = genNotification('warning')
    Vue.prototype.$info = genNotification('info')
    Vue.prototype.$success = genNotification('success')
  }
}

export default Notification



// WEBPACK FOOTER //
// ./src/helpers/notification.js